<template>
  <div class="update_page">
    <img src="../assets/update.jpg" alt="">
    <h2>系统维护中...</h2>
    <p>我们正在进行系统升级和维护，以提供更好的服务体验。请稍后再试。</p>
  </div>
</template>

<script>
export default {
  mounted () {
    document.title = '系统维护中';
  }
}
</script>

<style scoped lang="less">
.update_page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; 
  padding: 0 20px;
  img {
    margin-top: -40px;
    width: 50%;
    border-radius: 4px;
    opacity: .8;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #444;
    margin: 20px 0;
    font-weight: 600;
  }
  p {
    // font-size: 16px;
    color: #888;
    text-align: center;
    max-width: 600px;
  }
}
</style>